import { Box, Breadcrumbs, Chip, Link, Tooltip, Typography,  } from "@mui/material";
import { FC } from "react";


const Breadcrumb: FC<any> = ({ data }) => {
  
  return (
    <Box display="flex" sx={{ alignItems: "center" }} className="hand">
      <Breadcrumbs aria-label="breadcrumb">
        {data?.map((entry: any, index: number) => {
          const content = (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {entry?.icon && <Box sx={{ mr: 0.5, display: "flex", alignItems: "center" }}>{entry.icon}</Box>}
              <Typography sx={{ color: 'text.secondary' }} variant="h6">
                {entry?.label}
              </Typography>
            </Box>
          );

          const contentWithTooltip = entry?.tooltip ?  (
            <Tooltip title={entry?.tooltip}>{content}</Tooltip>
          ) : (
            content
          );

          return entry?.onClick ? (
            <Link
              key={index}
              underline="hover"
              color="inherit"
              onClick={entry.onClick}
              sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            >
              {contentWithTooltip}
            </Link>
          ) : (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
              {contentWithTooltip}
            </Box>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
